/** Shared playback clock for direct-video room screens (pure, unit-tested). */
export interface VideoSyncState {
  playing: boolean;
  /** Media time in seconds at the moment `at`. */
  t: number;
  /** Server-clock epoch ms when `t` was true. */
  at: number;
}

/** Where everyone's video should be at `nowMs` (server clock). Loops if `duration` is known. */
export function videoTimeAt(state: VideoSyncState, nowMs: number, duration?: number): number {
  const t = state.playing ? state.t + Math.max(0, nowMs - state.at) / 1000 : state.t;
  return duration && Number.isFinite(duration) && duration > 0 ? t % duration : t;
}

/** Seek only past this much drift — small corrections stutter worse than drift. */
export const RESYNC_THRESHOLD_S = 0.75;
export function needsResync(current: number, target: number): boolean {
  return Math.abs(current - target) > RESYNC_THRESHOLD_S;
}
